import { WmsService } from "../resource";
import swal from "sweetalert2";
import i18n from "./i18n";

const  WmsInventoryModule = {
  namespaced: true,
  state: {
    data: [],
    data_history: [],
    data_history_detail: [],
    keyword: "",
	data_storage: [],
	summary_product: [],
	summary_storage: [],
	isLoading:false,
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    },
    SET_DATA_HISTORY (state, data) {
      state.data_history = data
    },
    SET_DATA_HISTORY_DETAIL (state, data) {
      state.data_history_detail = data
    },
    SET_DATA_STORAGE (state, data) {
      state.data_storage = data
    },
	SET_DATA_SUMMARY (state, data) {
	  state.summary_product = data.detail_by_product
	  state.summary_storage = data.detail_by_storage
	},
  },
  actions: {
    SearchInventory({state},keyword){
      state.keyword = keyword
    },
    InventoryIn ({ commit, state }, data) {
        return WmsService.InventoryIn(data)
    },
    InventoryOut ({ commit, state }, data) {
        return WmsService.InventoryOut(data)
    },
    InventoryTransfer ({ commit, state }, data) {
      return WmsService.InventoryTransfer(data)
    },
    InventoryTransferByUser ({ commit, state }, data) {
      return WmsService.InventoryTransferByUser(data)
    },
    InventoryDelete ({ commit, state }, data) {
        return WmsService.InventoryDelete(data)
    },
    
    async HistoryDetail ({ commit, state },param) {
      try{
        const data = await WmsService.InventoryHistoryDetail(param)
        if (data.data == null) 
        {
          commit('SET_DATA_HISTORY_DETAIL', [])
        }
        else 
        {
          commit('SET_DATA_HISTORY_DETAIL', data.data)
        }
      }
      catch(err)
      {
      console.log(err)
        commit('SET_DATA_HISTORY_DETAIL', [])
      }
    },
    async listHistory ({ commit, state },param) {
      state.keyword = ""
      try{
        const data = await WmsService.InventoryHistory(param)
        if (data.data.Data == null) 
        {
          commit('SET_DATA_HISTORY', [])
        }
        else 
        {
          commit('SET_DATA_HISTORY', data.data.Data)
        }
      }
      catch(err)
      {
      console.log(err)
        commit('SET_DATA_HISTORY', [])
      }
    },
    async listData ({ commit, state },params) {
      state.keyword = ""
      try{
        const data = await WmsService.InventoryList(params)
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch(err)
      {
      console.log(err)
        commit('SET_DATA', [])
      }
    },
	async listHistoryStorage ({ commit, state },params) {
		state.isLoading = true
		swal.fire({
			title: i18n.t(`processing`),
			type: "info",
			allowEscapeKey: false,
			allowOutsideClick: false,
			onOpen: () => {
				swal.showLoading();
			}
		  });
		try{
		  const data = await WmsService.InventoryListByStorage(params)
			commit('SET_DATA_STORAGE', data.data.Datum.histories == null ? [] : data.data.Datum.histories)
			commit('SET_DATA_SUMMARY', data.data.Datum.QuantitySummary)
			swal.close()
			state.isLoading = false
		}
		catch(err)
		{
		  console.log(err)
		  commit('SET_DATA_STORAGE', [])
		  commit('SET_DATA_SUMMARY', {detail_by_product:[],detail_by_storage:[]})
		  state.isLoading = false
		  swal.fire({
		  title: i18n.t(err.response.data.Msg),
		  text: i18n.t(err.response.data.Cause),
		  icon: "error",
		  buttonsStyling: false,
		  confirmButtonClass: "btn btn-info btn-fill"
		  });
		}
	  },
    
  },
  getters: {
    getData (state) {
      return state.data
    },
    getHistory (state) {
      return state.data_history
    },
    getHistoryHead (state) {
      return state.data_history_detail.Head
    },
	getHistoryStorage (state) {
		return state.data_storage
	  },
    getHistoryDetail (state) {
      return state.data_history_detail.Data
    },
    getSearch(state){
      if (state.keyword != ""){

        return state.data.filter(item => (item.ProductName.indexOf(state.keyword) !== -1 || item.StorageName.indexOf(state.keyword) !== -1))

      } else {
        return state.data
      }
    },
    getInventoryName({state},id){
      let n =  state.data.filter( d => d.ID === id)[0]
      return n.StorageName + " - " + n.ProductName
    },
	getSummaryByStorage(state){
		return state.summary_storage
	},
	getSummaryByProduct(state){
		return state.summary_product
	}

  }
}

export default WmsInventoryModule
